__turbopack_context__.v({
  "icon": "EnergyTypeIcon-module-scss-module__IAMP1W__icon",
});
